import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function BlogSection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 border border-accent-300/60 rounded-full text-sm font-medium text-accent-700 bg-accent-100/80 mb-6 whitespace-nowrap">
            SEO Guides & Tips
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            AllChinaBuySpreadsheet
            <br />
            Resource Hub
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            In-depth guides, comparisons, and tutorials to help you master product sourcing
            with structured spreadsheet data. New articles added regularly.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-accent-700 whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}